module.exports = __webpack_public_path__ + "assets/img/comp_4.17aa571d.png";